<template>
<div class="w-100 product-root-container">
    <mdbContainer class="productContainer" v-loading="productLoading">
        <div class="d-flex flex-fill align-items-center mt-2 productHeaderContainer">
            <div class="productBodyItem">
                <mdb-btn color="elegant" size="sm" class="z-depth-0" @click="goBack">Back</mdb-btn>
            </div>
            <template v-if="productStatus== 'found'">
                <div class="productBodyItem text-right">
                    <template v-if="product">
                        
                        <mdb-btn color="elegant" size="sm" class="z-depth-0" @click="fnAddToCart" :disabled="disableActionButton">
                        <template v-if="disableActionButton">
                            <span class="spinner-border spinner-border-sm " role="status" aria-hidden="true"></span>
                            Please wait...
                        </template>
                        <template v-else>
                        {{ isExistInCart(product) ? 'Remove from selection' : 'Add to selection' }}
                        </template>
                        </mdb-btn>
                        </template>
                    </div>
            </template>
            </div>
    <template v-if="productStatus == 'notfound'">
        <div class="d-flex flex-fill align-items-center mt-2">
            <mdb-alert color="warning" class="w-100">
                <span>Product Not Found</span>
            </mdb-alert>
        </div>
    </template>
    <template v-else>

            <mdb-row class="mt-5 mb-5">
            <mdb-col cols="12" md="5">
                <a href="javascript:void(0)" @click="viewGallery(product)">
                            <img :src="product.U_imgURL" class="item-image w-100"  />
                        </a>
            </mdb-col>
            <mdb-col cols="12" md="7">


                <el-collapse v-model="activePaneNum">
                    <el-collapse-item title="PRODUCT DETAILS" name="product-details">
                        <dl class="row mt-1 mb-0">
                                <dt class="col-sm-12 col-md-4 col-lg-4"> NAME : </dt>
                                <dd class="col-sm-12 col-md-8 col-lg-8"> {{product.ItemName}} </dd>
                            </dl>
                            <dl class="row mt-0 mb-0">
                                <dt class="col-sm-12 col-md-4 col-lg-4"> ITEM CODE : </dt>
                                <dd class="col-sm-12 col-md-8 col-lg-8"> {{product.ItemCode}} </dd>
                            </dl>
                            <dl class="row mt-0 mb-0">
                                <dt class="col-sm-12 col-lg-4 col-md-4"> DIMENSION : </dt>
                                <dd class="col-sm-12 col-lg-8 col-md-8"> {{product.Dimension}} </dd>
                            </dl>
                            <!-- <dl class="row mt-1 mb-1">
                                <dt class="col-sm-6 col-lg-4 col-md-4"> QTY IN NETHERLANDS WAREHOUSE : </dt>
                                <dt class="col-sm-6 col-lg-8 col-md-8"> {{product.QuantityOnStock}}</dt>
                            </dl>
                            <dl class="row mt-1 mb-1">
                                <dt class="col-sm-6 col-lg-4 col-md-4"> UNDER PRODUCTION : </dt>
                                <dt class="col-sm-6 col-lg-8 col-md-8"> {{product.QuantityOrderedFromVendors}}</dt>
                            </dl> -->
                            <!-- <dl class="row mt-1 mb-1">
                                <dt class="col-sm-6 col-lg-4 col-md-4"> COMMITTED : </dt>
                                <dt class="col-sm-6 col-lg-8 col-md-8"> {{product.QuantityOrderedByCustomers}}</dt>
                            </dl> -->
                            <dl class="row mt-1 mb-1">
                                <dt class="col-sm-6 col-lg-4 col-md-4"> AVAILABLE : </dt>
                                <dt class="col-sm-6 col-lg-8 col-md-8"> {{product.Available}}</dt>
                            </dl>
                            
                    </el-collapse-item>
                    <template v-if="user">
                        <el-collapse-item title="PRICES" name="prices">
                            <template v-if="product.ItemPrices && product.ItemPrices.length > 0">
                                    <dl class="row mt-1 mb-1" v-for="(price,index) in product.ItemPrices" :key="index">
                                        <dt class="col-sm-6 col-lg-4 col-md-4"> {{ price.PriceListName }} : </dt>
                                        <dt class="col-sm-6 col-lg-8 col-md-8"> {{ $utils.formatMoney(price.Price)}} {{price.Currency}} </dt>
                                    </dl>
                                </template>
                                <template v-else>
                                    <div class="">No available data</div>
                                </template>
                        </el-collapse-item>

                     

                        <el-collapse-item title="WAREHOUSE INFORMATION" name="warehouse-information">
                            <template v-if="product.ItemWarehouseInfoCollection && product.ItemWarehouseInfoCollection.length > 0">

                                    <table class="table table-sm table-hover">
                                        <thead>
                                            <tr>
                                                <th scope="col">WAREHOUSE</th>
                                                <th scope="col">IN STOCK</th>
                                                <th scope="col">Under Production</th>
                                                <th scope="col">AVAILABLE</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="(price,index) in product.ItemWarehouseInfoCollection" :key="index">
                                                <td> {{ price.WarehouseName }} </td>
                                                <td> {{ price.InStock }} </td>
                                                <td> {{ price.Ordered }} </td>
                                                <td> {{ price.Available }} </td>
                                            </tr>
                                        </tbody>
                                    </table>

                                </template>
                                <template v-else>
                                    <div class="">No available data</div>
                                </template>
                        </el-collapse-item>
                    </template>

                    <el-collapse-item title="ESTIMATED TIME OF ARRIVAL" name="incoming-order">
                            <template v-if="product.IncomingOrders && product.IncomingOrders.length > 0">
                                    <table class="table table-sm table-hover">
                                            <thead>
                                                <tr>
                                                    <th scope="col">DATE</th>
                                                    <th scope="col">QUANTITY</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr v-for="(price,index) in product.IncomingOrders" :key="index">
                                                    <td> {{ price.U_etaDate }} </td>
                                                    <td> {{ price.Quantity }} </td>
                                                </tr>
                                            </tbody>
                                        </table>
                            </template>
                            <template v-else>
                                <div class="">No available data</div>
                            </template>
                        </el-collapse-item>

                </el-collapse>
                
            </mdb-col>
            </mdb-row>

            <CoolLightBox 
            ref="coolLightBox"
            :items="productImages" 
            :index="productImageIndex"
            :showCloseButton="true"
            :useZoomBar="true"
            :showThumbs="true"
            @close="productImageIndex = null">
            </CoolLightBox>
        </template>


    </mdbContainer>
</div>
</template>

<script>
import {mapActions, mapGetters} from 'vuex'
import {mdbRow, mdbCol, mdbBtn,  mdbContainer, mdbAlert} from 'mdbvue'
import CoolLightBox from '../components/CoolLightBox.vue'
export default {
    components : {
        mdbRow, mdbCol, mdbBtn,
        mdbContainer, mdbAlert,
        CoolLightBox
    },
    data : () => ({
        product : {},
        productLoading : false,
        productStatus : 'loading',
        activePaneNum :  ['product-details','prices'],
        disableActionButton : false,
        productImages : [],
        productImageIndex : null
    }), 
    mounted(){
        const self = this
        const item = this.$route.query.item;

       /*  if(item !== undefined && item !== null && item !== "" ){
            this.productLoading = true
            this.getProduct(item).then((response) => {


                console.log("response",response)
                self.product = {
                    ...response,
                    U_imgURL : response.U_imgURL.replace(/\/(small|thumb)-/, "/large-")
                }
                self.productLoading = false
                self.productStatus = 'found'
            }).catch((err) => {
                self.productLoading = false
                console.log("View Product error",err)
                self.productStatus = 'notfound'
            })
        }else{
            this.productStatus = 'notfound'
        } */
    },
    methods : {
        ...mapActions('ProductModule',[
            'resetData','getProduct'
        ]),
        ...mapActions('CartModule',[
            'addToCart','getCart','updateCart','deleteItem','placeOrder','createCart'
        ]),
        handlePaneOpened(num) {
            this.activePaneNum = num
        },
        goBack(){
            // this.$router.push({ name: 'welcome' });
            this.$router.go(-1);
        },
        fnAddToCart(){

            const swalWithBootstrapButtons = this.$swal.mixin({
                    customClass: {
                        confirmButton: 'btn btn-success',
                        cancelButton: 'btn btn-danger'
                    },
                    buttonsStyling: false
                })


            this.disableActionButton = true
            if(this.isExistInCart(this.product)){
                this.deleteItem(this.product).then(() => {
                    this.disableActionButton = false
                    /* this.$ThatsNotify.success({
                        message: "Item was succesfully removed from selection"
                    });
 */
                    swalWithBootstrapButtons.fire(
                        'Success!',
                        `Item was succesfully removed from selection`,
                        'success'
                    )
                });
            }else{
                this.addToCart(this.product).then(() => {
                    this.disableActionButton = false
                   /*  this.$ThatsNotify.success({
                        message: "Item was succesfully added to selection"
                    }); */

                    swalWithBootstrapButtons.fire(
                        'Success!',
                        `Item was succesfully added to selection`,
                        'success'
                    )
                });
            }
        },

        isExistInCart(item){
            return this.cart.findIndex((cartItem) => cartItem.ItemCode === item.ItemCode) > -1
        },
        viewGallery(product){
            if(product.Images.length > 0){
                this.productImages = product.Images.map((i) => {
                        return {
                            src : i,
                            description : product.Dimension,
                            title : product.ItemName
                        }
                    });

                this.productImageIndex = 0
            }
        },
    },
    computed : {
      ...mapGetters('CartModule',[
          'cart'
      ]),
      ...mapGetters('AuthModule',[
          'user'
      ])
    },
    watch : {
        '$route.query.item': {
            immediate: true,
            handler(newValue) {
                // console.log("new value",newValue);
                const self = this

                this.productLoading = true
                this.getProduct(newValue).then((response) => {


                    console.log("response",response)
                    self.product = {
                        ...response,
                        U_imgURL : response.U_imgURL.replace(/\/(small|thumb)-/, "/large-")
                    }
                    self.productLoading = false
                    self.productStatus = 'found'
                    
                }).catch((err) => {
                    self.productLoading = false
                    console.log("View Product error",err)
                    self.productStatus = 'notfound'
                })
            },
        },
    }
}

</script>
<style scoped lang="scss">
.productHeaderContainer{
    border-bottom: 1px solid #e0e0e0;
}
.productBodyItem{
    flex: 1 1 calc(50% - 10px); 
      box-sizing: border-box; 
      .btn{
        padding-left: 10px;
        padding-right: 10px
      }
}

/* .productContainer{
    margin-top: 100px
} */
</style>